import React from 'react';
import * as PropTypes from 'prop-types';

function CommonErrorLabel({ value }) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{value && <label className="error-label">{value}</label>}</>;
}

CommonErrorLabel.defaultProps = {
  value: '',
};

CommonErrorLabel.propTypes = {
  value: PropTypes.string,
};

export default CommonErrorLabel;
